import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { FadeIn } from '../components/FadeIn';
import { useModals } from '../contexts/ModalContext';
export function PostJob() {
  const {
    openModal
  } = useModals();
  useEffect(() => {
    document.title = "Post a Job | Care Nomad";
    // Automatically open the talent modal when they land on this page
    openModal('talent');
  }, [openModal]);
  return <div className="min-h-screen w-full bg-gray-50 flex flex-col" data-id="element-1958" data-mp="lzo1oo19gz57">
      <Navbar data-id="element-1959" data-mp="lyw63d7nz1ex" />
      
      <main className="flex-1 flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1960" data-mp="m1ihjnxoe12f">
        <FadeIn direction="up" className="max-w-2xl mx-auto" data-id="element-1961" data-mp="c9uqvp8y0o20">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1a2332] mb-6" data-id="element-1962" data-mp="c89udu32iv1i">Let's find your perfect match.</h1>
          <p className="text-lg text-[#5a6a7a] mb-10" data-id="element-1963" data-mp="zxcdz7h9ixyn">
            Please fill out the intake form that just opened to tell us what you're looking for. If you closed it by mistake, you can reopen it below.
          </p>
          <button onClick={() => openModal('talent')} className="bg-[#5a55ea] hover:bg-[#4b47c4] text-white font-bold py-4 px-8 rounded-xl transition-colors shadow-lg text-lg" data-id="element-1964" data-mp="nuecdkcnwbyo">
            Open Intake Form
          </button>
        </FadeIn>
      </main>

      <StickyFooter data-id="element-1965" data-mp="xqpwgwihu63o" />
    </div>;
}